/**
 * Component Registry for Juniper
 * 
 * Inherits from @vibesites-amc-preferred-theme/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-amc-preferred-theme/theme-preferred/registry';
import { AmenitiesList } from './components/AmenitiesList';
import { Hero } from './components/Hero';
import { HomeReviews } from './components/HomeReviews';
import { PropertyOverview } from './components/PropertyOverview';
import { ReviewsCallout } from './components/ReviewsCallout';

/**
 * Property-specific component overrides.
 * Uncomment and customize components as needed.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  // Marks select-unit amenities with '*' and shows a footnote disclaimer.
  AmenitiesList,
  // Local override of the parent Hero: removes the dark overlay so the
  // background image reads at full brightness.
  Hero,
  // Match AmenitiesList collection order (drop parent featured/desirability sort).
  PropertyOverview,
  // Force-unhides Multihub's property-level display:none on this slot.
  ReviewsCallout,
  // Preferred home slot going forward (pages.json); avoids the hidden slot name.
  HomeReviews,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
